import { defineElement, html } from '@webtides/element-js';
import BaseCheckboxField from '../../../../legacy-library/webcomponents/_form/checkbox-field/checkbox-field.class';
import style from './checkbox-field.css';

export default class CheckboxField extends BaseCheckboxField {
    constructor() {
        super({ styles: [style] });
    }

    selectedIndicatorTemplate() {
        return html` <svg-icon name="check" class="checked w-full h-full"></svg-icon> `;
    }
}

defineElement('checkbox-field', CheckboxField);
